import { render, staticRenderFns } from "./BotKnowledgeWidget.vue?vue&type=template&id=a062a7ec&scoped=true&"
import script from "./BotKnowledgeWidget.vue?vue&type=script&lang=js&"
export * from "./BotKnowledgeWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a062a7ec",
  null
  
)

export default component.exports